import * as sendRecord from '../services/sendRecord';

export default {
  namespace: 'sendRecord',
  state: {},
  effects: {
    *getQueryMailSendLogPage({ payload: { values } }, { call, put }) {
      const response = yield call(sendRecord.getQueryMailSendLogPage, values);
      yield put({
        type: 'save',
        payload: {
          sendRecordList: response.data.data,
          total: response.data.total,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
